import React, { Component } from 'react';
import { CustomInput } from 'reactstrap';

const passHasDigit = password => /\d/.test(password);

const passHasUpper = password => /[A-Z]/.test(password);

const passHasLength = (password, length = 6) =>
  !!password && password.length >= length;

export default class PasswdChecker extends Component {
  static validate = (errors, values) => {
    if (
      values.password &&
      values.password2 &&
      values.password !== values.password2
    ) {
      errors.password2 = 'пароли не совпадают';
    }

    if (values.password) {
      if (
        !passHasDigit(values.password) ||
        !passHasUpper(values.password) ||
        !passHasLength(values.password)
      ) {
        errors.password = 'пароль не отвечает уcловиям безопасности';
      }
    }

    return errors;
  };

  render() {
    const { password } = this.props;
    return (
      <div className='mt-1'>
        <CustomInput
          type='checkbox'
          checked={passHasLength(password, 6)}
          id='markMinLength'
          label='длина пароля более 6 символов'
          onClick={e => e.preventDefault()}
          disabled={!passHasLength(password, 6)}
          tabIndex='-1'
          readOnly
        />
        <CustomInput
          type='checkbox'
          checked={passHasUpper(password)}
          id='markHasUpper'
          label='пароль содержит как минимум одну заглавную латинскую букву'
          onClick={e => e.preventDefault()}
          disabled={!passHasUpper(password)}
          tabIndex='-1'
          readOnly
        />
        <CustomInput
          type='checkbox'
          checked={passHasDigit(password)}
          id='markHasDigit'
          label='пароль содержит как минимум одну цифру'
          onClick={e => e.preventDefault()}
          disabled={!passHasDigit(password)}
          tabIndex='-1'
          readOnly
        />
      </div>
    );
  }
}
